// extracted by mini-css-extract-plugin
export var button = "PostGrid-module--button--09E7q";
export var postGrid = "PostGrid-module--post-grid--PUbW5";